<template>
  <div id="in-event-controller">       
    <div class="clock-row">
        <div class="title-div">
          <div style="flex-grow: 1">
            <div style="width: 21px; height: 20px; background-repeat: no-repeat" :style="sportIcon"></div>
          </div>
          <div class="title-logo" style="flex-grow: 2;">
          </div>
          <div class="live-indicator-container" style="width: 400px; flex-grow: 2">
            <div class="live-indicator-line"></div>
            <div class="live-indicator" :class="isLive ? '' : 'offline'">LIVE<br/>Score Provider - {{provider.text}} </div>
            <div class="live-indicator-line"></div>
          </div>
        </div>
    </div>
    <div class="clock-row">
      <a v-if="!allowEditClock" @click="editClock()" class="button is-info set-clock-button">SET</a>
      <a v-if="allowEditClock" @click="setClock()" class="button is-info send-clock-button">SEND</a>
      <a @click="swapDirection()" class="button is-info direction-clock-button" :style="directionIcon"></a>
      <div class="clock-containter">
        <div class="clock">
          <input v-if="allowEditClock" type="number" class="timer-picker minutes" v-model="minutes" id="timer-minutes" min="0" max="999" pattern="[0-9]*" />
          <counter-container v-if="!allowEditClock" name="Minutes" :value="minutes" :small="true" :digits="3" ref="counterContainerMinutes"></counter-container>
          :
          <input v-if="allowEditClock" v-model="seconds" type="number" class="timer-picker seconds" id="timer-seconds" min="0" max="59" pattern="[0-9]*" />
          <counter-container v-if="!allowEditClock" name="Seconds" :value="seconds" :small="true" :digits="2" ref="counterContainerSeconds"></counter-container>          
        </div>
      </div>
      <a @click="startStopClock()" class="button is-info start-stop-clock-button" :class="clockStarted ? 'is-danger' : ''"> {{ clockStarted ? "STOP" : "START" }}</a>
    </div>
    <div class="ui-section">
      <div class="score-containers">
          <counter-container name="One" :digits="3" ref="counterContainerOne"></counter-container>
          <div class="score-seperator"> - </div>
          <counter-container name="Two" :digits="3" ref="counterContainerTwo"></counter-container>
      </div>
      <div class="score-changers">
        <score-changer class="score-changer left" :teamName="homeName" linkedCounter="counterContainerOne" @clickUp="homeClickUp" @clickDown="homeClickDown" homeAway="HOME"></score-changer>      
        <score-changer class="score-changer right" :teamName="awayName" linkedCounter="counterContainerTwo" @clickUp="awayClickUp" @clickDown="awayClickDown" homeAway="GUEST"></score-changer>              
      </div>     
    </div>
    <div class="ui-section">
      <div class="period-section">
        <div class="inner-section-div">
          <span>PERIOD LENGTH</span>
          <div class="section-time-text" style="margin-left: 20px">{{ numberFormat(periodLength) }} <span class="section-time-text" style="color: #696969">m</span></div>
          <section-arrows style="margin-left: 20px" @up="sectionArrowClicked('up', 'period-length')" @down="sectionArrowClicked('down', 'period-length')"></section-arrows>
        </div>
      </div>
    </div>
    <div class="ui-section">
      <div class="period-section">
        <div class="inner-section-div">
          <span style="margin-right: 21px">SET PERIOD</span>
          <div v-for="number in 5" class="period-button" :class="number == selectedPeriod ? 'selected' : ''" style="margin-left: 6px" @click="setPeriod(number)">{{ (number < 5) ? number : "OT" }}</div>
        </div>
      </div>
    </div>
    <div class="ui-section" v-if="false"> <!-- selectedPeriod < 5 -->
      <div class="period-section">
        <div class="inner-section-div">
          <span>EXTRA TIME</span>
          <div class="section-time-text" style="margin-left: 60px">{{ numberFormat(extraTime) }} <span class="section-time-text" style="color: #696969">m</span></div>
          <section-arrows style="margin-left: 20px" @up="sectionArrowClicked('up', 'extra-time')" @down="sectionArrowClicked('down', 'extra-time')"></section-arrows>
        </div>
      </div>
    </div>
    <div class="ui-section" v-if="false"> <!-- selectedPeriod == 5 -->
      <div class="period-section">
        <div class="inner-section-div">
          <span>OVER TIME</span>
          <div class="section-time-text" style="margin-left: 65px">{{ numberFormat(overTime) }} <span class="section-time-text" style="color: #696969">m</span></div>
          <section-arrows style="margin-left: 20px" @up="sectionArrowClicked('up', 'extra-time')" @down="sectionArrowClicked('down', 'extra-time')"></section-arrows>
        </div>
      </div>
    </div>
    <div class="ui-section" v-if="currentSportsType == 'soccer'">
      <div class="cards-section">
          <cards name="HOME" @yellowCardClicked="cardClicked('1', 'Yellow')" @redCardClicked="cardClicked('1', 'Red')"></cards>
          <div style="display: flex; flex-direction: column; justify-content: center">
            <div class="card-title" style="color: #a7a7a7">CARDS</div>
            <div style="display: flex; flex-direction: row; justify-content: center">
              <div class="cards-seperator"></div>
            </div>
          </div>
          <cards name="GUEST" @yellowCardClicked="cardClicked('2', 'Yellow')" @redCardClicked="cardClicked('2', 'Red')"></cards>
      </div>
    </div>
    <div class="ui-section" v-if="showPresets">
      <div class="period-section">
        <div class="inner-section-div">
          <span style="margin-right: 21px">PRESETS</span>
          <div v-for="(item, index) in vpuPresets" class="button is-info set-clock-button" style="margin-right: 20px" @click="presetClicked(item.preset)">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="ui-section" v-for="layer in controllerSwitches" v-if="showLayers">
      <div class="period-section">
        <div class="inner-section-div">
          <span style="width: 250px;">{{ layer.name }}</span>
          <b-switch @input="changeLayerState(layer.state, layer.id)" v-model="layer.state" style="margin-left: 0px"
              type="is-success"
              :true-value="true"
              :false-value="false"
              :disabled="disableSwitches"
              size="is-medium">
          </b-switch>       
        </div>
      </div>
      <div class="layer-container">
        <div v-if="isPicture(layer.type)" class="layer-image-container">
          <img style="max-width:80px; max-height: 60px" :src="layer.value" />
        </div>
        <div v-if="!isPicture(layer.type)" class="layer-text-container">
          <div style="font-size: 16px;">{{ layer.value }}</div>
        </div>
      </div>      
    </div>

    <div class="switch-container" style="display: none">
      <div style="width: 250px;">
        <span>Scoreboard</span><span> | </span><span v-bind:style="{ color: scoreBoardON ? '#7ed321' : '#bf0017' }">{{ scoreBoardON ? "ON" : "OFF" }}</span>       
      </div>
      <div>
        <b-switch v-model="scoreBoardON"
            type="is-success"
            :true-value="true"
            :false-value="false"
            size="is-medium">
        </b-switch>       
      </div>
      
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import { eventBus } from '../main'

var moment = require('moment');
var debounce = require('debounce');
var proto_messages = require("../proto/ManualScoreboard_pb.js");
var vpu_control_messages = require("../proto/HdApi_pb.js");

export default {
    data() {
        return {
          scoreBoardON: false,
          seconds: this.$store.getters.getSeconds,
          minutes: this.$store.getters.getMinutes,
          homeTeamName: this.$store.getters.homeName,
          awayTeamName: this.$store.getters.awayName,
          provider: this.$store.getters.getScoreboardProvider,
          disableSwitches: false,
          vpuPresets: [{name: 'Left', preset: 'leftside'}, {name: 'Center', preset: 'center'}, {name: 'Right', preset: 'rightside'}, {name: 'AP', preset: 'autoproduction'}],
          isLive: false,
          icons: {
            'americanfootball' : require('../assets/images/sports/american_football.svg'),
            'basketball' : require('../assets/images/sports/basketball.svg'),
            'beachvolleyball' : require('../assets/images/sports/beach_volleyball.svg'),
            'fieldhockey' : require('../assets/images/sports/field_hockey.svg'),
            'soccer' : require('../assets/images/sports/football.svg'),
            'futsal' : require('../assets/images/sports/futsal.svg'),
            'gymnastic' : require('../assets/images/sports/gymnastic.svg'),
            'hockey' : require('../assets/images/sports/hockey.svg'),
            'roller' : require('../assets/images/sports/roller.svg'),
            'rugby' : require('../assets/images/sports/rugby.svg'),
            'volleyball' : require('../assets/images/sports/volleyball.svg')
          }, 
          allowEditClock: false,
          directionIcons: [require('../assets/images/clock_direction_up.svg'), require('../assets/images/clock_direction_down.svg')]
        };
    },
    mounted() {
      mixpanel.track("Manual Scoreboard UI Started");
      this.scoreboardStateLogger();
    },
    created () {
      eventBus.$on('firstConnection', data => {
          console.log(data);

          this.$refs["counterContainerOne"].jumpToNumber(data.HomeScore);
          this.$refs["counterContainerTwo"].jumpToNumber(data.AwayScore);
      });

      eventBus.$on('liveIndication', connected => {
        this.isLive = connected;
      });
      
    },
    computed: {
        ...mapGetters({
          homeScore: "homeScore",
          homeName: "homeName",
          awayScore: "awayScore",
          awayName: "awayName",
          clockSeconds: "getSeconds",
          clockMinutes: "getMinutes",
          clockStarted: "getClockStarted",
          singularURL: "getSingularURL",
          currentSportsType: "getCurrentSportsType",
          clockDirection: "getClockDirection",
          selectedPeriod: "getSelectedPeriod",
          periodLength: "getPeriodLength",
          extraTime: "getExtraTime",
          overTime: "getOverTime",
          showLayers: "getShowLayers",
          controllerSwitches: "getControllerSwitches",
          showPresets: "getShowPresets",
          needsOverride: "getNeedsOverride",
          scoreboardProvider: "getScoreboardProvider"
        }),
        sportIcon() {
          return { 'background-image': 'url("' + this.icons[this.currentSportsType] + '")' }
        },
        directionIcon() {
          return { 'background-image': 'url("' + this.directionIcons[this.clockDirection]  + '")' }
        },
        minutesFormated() {
          var ret = this.clockMinutes;
          if (this.clockMinutes < 10)
            ret = "0" + ret;
          
          return ret;
        },
        secondsFormated() {
          var ret = this.clockSeconds;
          if (this.clockSeconds < 10)
            ret = "0" + ret;
          
          return ret;
        }
    },
    watch: {
      clockSeconds: function(newValue, oldValue) {
        this.seconds = newValue;
      },
      clockMinutes: function(newValue, oldValue) {
        this.minutes = newValue;
      },
      scoreboardProvider: function(newValue, oldValue) {
        this.provider = newValue;
      },   
    },
    methods: {
      changeLayerState(value, id) {
        this.$store.dispatch("checkManualOverride").then(result => {
          if(!result)
          {
            return;
          }
          this.$store.commit("setLayerState", { Id: id, State: value});
          this.disableSwitches = true;
          var self = this;
          setTimeout(() => {
            self.disableSwitches = false;
          }, 500);
        });
      },
      isPicture(value) {
        return (value == proto_messages.ControlType.PICTURE);
      },
      numberFormat(number) {
        var ret = number;
        if (number < 10)
          ret = "0" + ret;
        
        return ret;
      },     
      setPeriod(number) {
        this.$store.dispatch("checkManualOverride").then(result => {
          if(!result)
          {
            return;
          }
          if (this.selectedPeriod != number)
          {
            var p = (number < 5) ? number : "OT";
            var answer = confirm("Switch to " + p + " period?");
            if (answer == true)
            {
              if (this.clockDirection == proto_messages.ClockDirection.CLOCK_DIRECTION_DOWN)
              {
                this.$store.dispatch('startClock', {Seconds: 0, Minutes: parseInt(this.periodLength)});
              }
              this.$store.commit("setSelectedPeriod", number);            
            }
          }
        });
      },
      swapDirection() {
        this.$store.commit('swapDirection');
      },  
      cardClicked(team, color) {
        this.$store.dispatch("checkManualOverride").then(result => {
          if(!result)
          {
            return;
          }
          var answer = confirm("You are about to set " + color + " card to " + team + " team.\nAre you sure?");
          if (answer == true)
          {
            this.$store.commit('setCard', "Team" + team + "Card" + color);
          }
        });
      },
      presetClicked(preset) {
        var answer = confirm("You are about to set preset to " + preset + ".\nAre you sure?");
        if(answer == true)
        {
          var pm = new vpu_control_messages.ProductionInstructionMessage();
          pm.setType(preset);
          pm.setUpdate(vpu_control_messages.ProductionInstructionMessage.UpdateType.INSTRUCTION);
          this.$store.dispatch('sendMessageAsCoordinatorMessage', {msg: pm, msgType: 'HdApi.ProductionInstructionMessage'});
        }
      },
      sectionArrowClicked(direction, section) {
        this.$store.dispatch("checkManualOverride").then(result => {
          if(!result)
          {
            return;
          }
          if (section == "period-length")
          {
            console.log(direction)
            this.$store.dispatch('sendPeriodLength', (direction == "up") ? 1 : -1 );
          }
        });
      },
      homeClickUp() {
        this.$store.dispatch("checkManualOverride").then(result => {
          if(!result)
          {
            return;
          }
          console.log("Home click up");
          this.$store.commit('setHomeScore', this.homeScore + 1);
          mixpanel.track("Home score click up");
        });
      },
      homeClickDown() {
        this.$store.dispatch("checkManualOverride").then(result => {
          if(!result)
          {
            return;
          }
          console.log("Home click down");
          mixpanel.track("Home score click down");        
          
          if (this.homeScore == 0)
            return; // Don't allow sub zero score

          this.$store.commit('setHomeScore', this.homeScore - 1);
          });
      },
      scoreboardStateLogger(){
        this.intervalid1 = setInterval(function(){
          this.$store.dispatch('logScoreboardState');
        }.bind(this), 30000);
      },
      awayClickUp() {
        this.$store.dispatch("checkManualOverride").then(result => {
          if(!result)
          {
            return;
          }
          console.log("Away click up");
          this.$store.commit('setAwayScore', this.awayScore + 1);
          mixpanel.track("Away score click up");
        });
      },
      awayClickDown() {
        this.$store.dispatch("checkManualOverride").then(result => {
          if(!result)
          {
            return;
          }
          console.log("Away click down");
          mixpanel.track("Away score click down");        
          
          if (this.awayScore == 0)
            return; // Don't allow sub zero score

          this.$store.commit('setAwayScore', this.awayScore - 1);
        });
      },      
      editClock() {
        this.$store.dispatch("checkManualOverride").then(result => {
          if(!result)
          {
            return;
          }
          this.allowEditClock = true;
          this.$store.dispatch('stopClock');
        });
      },
      setClock(){
        this.$store.dispatch("checkManualOverride").then(result => {
          if(!result)
          {
            return;
          }
          this.$store.dispatch('setClock', {Seconds: parseInt(this.seconds), Minutes: parseInt(this.minutes)});
          this.allowEditClock = false;
        });
      },
      startStopClock() {
        this.$store.dispatch("checkManualOverride").then(result => {
          if(!result)
          {
            return;
          }
          if (this.clockStarted) {
            this.$store.dispatch('stopClock');
            mixpanel.track("Stop clock");
          }
          else
          {
            this.$store.dispatch('startClock', {Seconds: parseInt(this.seconds), Minutes: parseInt(this.minutes)});
            mixpanel.track("Start clock");
            this.allowEditClock = false;
          }
        });
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ScoreController.vue